import { render, staticRenderFns } from "./AdminCompanies.vue?vue&type=template&id=66035315"
import script from "./AdminCompanies.vue?vue&type=script&lang=js"
export * from "./AdminCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66035315')) {
      api.createRecord('66035315', component.options)
    } else {
      api.reload('66035315', component.options)
    }
    module.hot.accept("./AdminCompanies.vue?vue&type=template&id=66035315", function () {
      api.rerender('66035315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminCompanies.vue"
export default component.exports